import { render, staticRenderFns } from "./chi-siamo.vue?vue&type=template&id=2bb10224&scoped=true"
import script from "./chi-siamo.vue?vue&type=script&lang=ts"
export * from "./chi-siamo.vue?vue&type=script&lang=ts"
import style0 from "./chi-siamo.vue?vue&type=style&index=0&id=2bb10224&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb10224",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CoreSearchWrapper: require('/usr/src/nuxt-app/components/core/SearchWrapper.vue').default,CoreSelectTheSelect: require('/usr/src/nuxt-app/components/core/select/TheSelect.vue').default,ChiSiamoTheMap: require('/usr/src/nuxt-app/components/chi-siamo/TheMap.vue').default})
